module.exports = __webpack_public_path__ + "06_mustache_brown.58288df2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer3/06_mustache_brown.png
// module id = QBFB
// module chunks = 0